import { injectable } from "inversify";
import { LogSink, LogLevel } from "./models";

@injectable()
export default class LogMux implements LogSink {
  private sinks: Set<LogSink> = new Set();
  private disabledSinks: Set<LogSink> = new Set();

  registerSink(sink: LogSink) {
    if (!this.disabledSinks.has(sink)) {
      this.sinks.add(sink);
    }
  }

  private disableSink(sink: LogSink) {
    this.disabledSinks.add(sink);
    this.sinks.delete(sink);
  }

  async push(logLevel: LogLevel, message: string) {
    const results = await Promise.all(
      Array.from(this.sinks).map(sink =>
        sink
          .push(logLevel, message)
          .then(() => null)
          .catch((error: any) => [sink, error])
      )
    );
    if (results == null) {
      return;
    }
    const errors = (results as any[]).filter(value => value !== null);

    /** In order to prevent an infinite loop, we disable any failing sink. */
    for (const [sink, error] of errors) {
      this.disableSink(sink);
    }

    if (errors.length === 1) {
      throw errors[0][1];
    } else if (errors.length) {
      throw errors.map(value => value[1]);
    }
  }
}
